import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
  section?: 'overview' | 'permission' | 'behaviors' | 'malicious' | '';
}

export const RulesTab = ({ ruleSummaries, analysisId, section = 'overview' }: IProps) => {
  const filtersConfig = getRuleFiltersConfigBySection({ ruleSummaries, section });
  return <FiltersAndTable filtersConfig={filtersConfig} analysisId={analysisId} data={ruleSummaries} />;
};
